const STORE_KEY = 'LARIN_VARIANTS'

export const FETCH_LARIN_VARIANTS = `${STORE_KEY}/FETCH_LARIN_VARIANTS`
